<template>
	<div class="checkout-item" :class="{ editing: showingEditOptions }">
		<div class="checkout-item-quantity">
			<button
				class="btn-checkout-item-quantity"
				v-if="editable"
				@click="changeQuantity(1)"
			>
				<i class="sk-icon-chevron-up"></i>
			</button>
			<span class="quantity-count">{{ item.quantity }}</span>
			<button
				class="btn-checkout-item-quantity"
				v-if="editable"
				:disabled="decrementDisabled"
				@click="changeQuantity(-1)"
			>
				<i class="sk-icon-chevron-down"></i>
			</button>
		</div>
		<div class="checkout-item-description">
			<div class="checkout-item-title">
				<span class="checkout-item-name" @click="editClicked">
					<span>{{ item.name }}</span>
					<br />
				</span>
				<span class="checkout-item-price" v-if="showPrice">
					{{ totalPrice | currency }}
				</span>
				<button
					class="button button-transparent remove-button"
					v-if="editable"
					@click="deleteClicked"
				>
					<i class="sk-icon-times"></i>
				</button>
			</div>

			<div class="checkout-item-meta-options-group">
				<div
					class="checkout-item-meta-title"
					v-for="(options, key) in item.options"
					:key="key"
				>
					<!-- {{ key }}: -->
					<span
						class="checkout-item-meta-option"
						v-for="option in options"
						:key="option.id"
						:data-cy="`checkout-item-option-${option.id}`"
					>
						{{ option.name }}
					</span>
				</div>
			</div>

			<div class="utensils-and-name">
				<span class="checkout-item-subtitle" v-if="showRestaurantName">
					<i
						v-if="brandName"
						class="sk-icon-utensils-solid utensils"
					></i>
					{{ brandName ? brandName : "" }}
				</span>
			</div>
			<div class="checkout-item-meta-title" v-if="item.comments">
				Instructions:
				<div
					class="checkout-item-meta-option"
					:data-cy="`item-instructions-${item.id}`"
				>
					{{ item.comments }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import currencyFilterMixin from "@/mixins/currency-filter-mixin"

export default {
	name: "CheckoutItem",
	mixins: [currencyFilterMixin],
	data: function () {
		return {
			showingEditOptions: false
		}
	},
	props: {
		item: Object,
		editable: {
			type: Boolean,
			default: true
		},
		showRestaurantName: {
			type: Boolean,
			default: true
		},
		showPrice: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		brandName() {
			const brands = this.$store.state.brands
			const brandId = this.$store.getters.menuBrandsMap[this.item.menu_id]
			if (brands && brandId) {
				const brand = brands.find((brand) => brandId == brand.id)
				return brand.name
			}
		},
		totalPrice() {
			return (
				Object.values(this.item.options)
					.flat()
					.reduce(
						(previous, current) => previous + current.price,
						parseFloat(this.item.price)
					) * this.item.quantity
			)
		},
		decrementDisabled() {
			return this.item.quantity <= 1
		}
	},
	methods: {
		changeQuantity(value) {
			this.$store.dispatch("sendMixpanelEvent", {
				msg:
					value > 0
						? "Cart Item Quantity Increase"
						: "Cart Item Quantity Decrease",
				data: {
					id: this.item.id
				}
			})
			this.$store.dispatch("updateItemCount", {
				quantity: this.item.quantity + value,
				item: this.item
			})
		},
		editClicked() {
			if (!this.editable) {
				return
			}
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Cart Item Edit Clicked",
				data: {
					id: this.item.id
				}
			})
			this.$store.dispatch("editItem", this.item)
			this.$router.push({
				query: {
					item_id: this.item.id,
					menu_id: this.item.menu_id,
					editing: "true"
				}
			})
		},
		deleteClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Cart Item Remove Clicked",
				data: {
					id: this.item.id
				}
			})
			this.$store.dispatch("removeItemFromCart", this.item)
		}
	}
}
</script>

<style scoped>
.checkout-item {
	padding: 15px 0 15px 16px;
	min-height: 90px;
	display: flex;
	background: var(--gR-white);
}

.checkout-item-quantity {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.btn-checkout-item-quantity {
	padding: 0 5px;
	background: none;
}

.btn-checkout-item-quantity:disabled {
	display: hidden;
}

.btn-checkout-item-quantity i {
	font-size: 12px;
}

.quantity-count {
	font-weight: 600;
}

.checkout-item-description {
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex: 1;
	margin-left: 25px;
}

.checkout-item-title {
	font-weight: 600;
	display: flex;
	font-size: 14px;
}

.checkout-item-title,
.checkout-item-name,
.checkout-item-name span:not(.checkout-item-subtitle),
.checkout-item-price,
.quantity-count {
	color: var(--gR-base-80);
}

.checkout-item-name {
	padding-right: 10px;
	flex: 1;
}

.checkout-item-name span:first-child {
	margin-right: 10px;
}

.checkout-item-subtitle {
	font-size: 11px;
	font-weight: 500;
	color: var(--sk-grey3);
}

.checkout-item-meta-options-group {
	padding-top: 2px;
	padding-right: 20px;
	display: flex;
	flex-wrap: wrap;
}

@media only screen and (max-width: 750px) {
	.checkout-item-meta-options-group {
		padding-right: 40px;
	}
}

.checkout-item-meta-title:not(:last-child):after {
	content: ",\00a0";
	margin-left: -2px;
}

.checkout-item-meta-option:not(:last-child):after {
	content: ",\00a0";
	margin-left: -2px;
}

.checkout-item-meta-title,
.checkout-item-meta-option {
	font-size: 10px;
}

.checkout-item-meta-title {
	color: var(--sk-grey);
}

.checkout-item-meta-option {
	color: var(--sk-grey3);
	font-weight: 400;
}

.remove-button {
	height: 10px;
	width: auto;
	margin-right: 10px;
	margin-top: 7px;
	margin-left: 10px;
}

.remove-button i {
	font-size: 10px;
	color: var(--sk-grey2);
}

.utensils {
	opacity: 0.7 !important;
	padding-right: 4px;
}

.utensils-and-name {
	display: flex;
	align-items: center;
}
</style>
